module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-lincoln.27337cb7.png";